import { render, staticRenderFns } from "./IdLikeToOrganizationSection.vue?vue&type=template&id=ba75827e"
import script from "./IdLikeToOrganizationSection.vue?vue&type=script&lang=js"
export * from "./IdLikeToOrganizationSection.vue?vue&type=script&lang=js"
import style0 from "./IdLikeToOrganizationSection.vue?vue&type=style&index=0&id=ba75827e&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports